enum EnvironmentType {
    Development = 'Development',
    Test = 'Test',
    UAT = 'UAT',
    Production = 'Production',
}

export const isDev = window.APP_CONFIG.ENVIRONMENT === EnvironmentType.Development;
export const isTest = window.APP_CONFIG.ENVIRONMENT === EnvironmentType.Test;
export const isUat = window.APP_CONFIG.ENVIRONMENT === EnvironmentType.UAT;
export const isProd = window.APP_CONFIG.ENVIRONMENT === EnvironmentType.Production;
